import { useState, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const INITIAL_FORM = {
  organization_name: "", contact_person: "", email: "", phone: "",
  standard_requested: "", message: "",
  details: {
    address: "", city: "", country: "", website: "", job_title: "",
    scope: "", num_employees: "", num_sites: "1", cert_type: "", existing_certs: "",
    implementation_status: "", consultant_used: "", preferred_audit_date: "",
  },
};

export function useContactForm() {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submissionId, setSubmissionId] = useState(null);
  const [form, setForm] = useState(INITIAL_FORM);

  const updateField = useCallback((key, val) => {
    setForm((prev) => ({ ...prev, [key]: val }));
  }, [setForm]);

  const updateDetail = useCallback((key, val) => {
    setForm((prev) => ({ ...prev, details: { ...prev.details, [key]: val } }));
  }, [setForm]);

  const canProceed = useCallback(() => {
    if (step === 1) return form.organization_name && form.contact_person && form.email;
    if (step === 2) return form.standard_requested;
    return true;
  }, [step, form.organization_name, form.contact_person, form.email, form.standard_requested]);

  const handleSubmit = useCallback(async () => {
    if (!form.organization_name || !form.contact_person || !form.email || !form.standard_requested) {
      toast.error("Please fill in all required fields.");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/contact`, form);
      toast.success("Application submitted successfully.");
      setSubmissionId(res.data.id);
      setSubmitted(true);
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [form]);

  const resetForm = useCallback(() => {
    setSubmitted(false);
    setSubmissionId(null);
    setStep(1);
    setForm(INITIAL_FORM);
  }, [setForm, setStep, setSubmitted, setSubmissionId]);

  return { step, setStep, loading, submitted, submissionId, form, updateField, updateDetail, canProceed, handleSubmit, resetForm };
}
